<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    theme: {
      type: String,
      default: 'default',
    },
  },
  methods: {
    clickRadio() {
      this.$emit('change', this.value)
    },
  },
}
</script>

<template>
  <div
    :class="{
      [$style.radioContainer]: theme === 'default',
      [$style.radioSimpleContainer]: theme === 'simple',
      [$style.selected]: modelValue === value,
    }"
    @click="clickRadio">
    <input
      type="radio"
      v-bind="$attrs"
      :name="name"
      :value="value"
      :checked="modelValue === value"
      @change="clickRadio" />
    <p>{{ label }}</p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.radioContainer {
  display: flex;
  padding: 12px 32px;
  color: $dark-gray;
  cursor: pointer;
  border: 1px solid $light-gray;
  border-radius: 48px;

  &.selected {
    color: $primary-blue;
    border: 1px solid $primary-blue;
  }

  > input {
    accent-color: $primary-blue;
    margin-right: 18px;
  }

  > p {
    font-size: 14px;
    font-weight: 700;
    color: currentColor;
    letter-spacing: 0.3px;
  }
}

.radioSimpleContainer {
  display: flex;
  color: $dark-gray;
  cursor: pointer;
  border-radius: 48px;

  &.selected {
    color: $primary-blue;
  }

  > input {
    accent-color: $primary-blue;
    margin-right: 8px;
  }

  > p {
    color: currentColor;
  }
}
</style>
